import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";
import { dbPayload } from "../registered/SEC_00_DB_Payload";
import { authClient } from "../api/authClient";

// Sustina's plug-in to the @nrgpix/auth-sso package: every package call goes to
// nrgCore SsoController (api/v1/auth/sso/*) through the site's own secure client,
// so SITE-KEY and the session headers are Sustina's business, not the package's.
const BASE = "/api/v1/auth/sso";
const siteKey = process.env.REACT_APP_SITE_KEY;

export const ssoApi = async (op, body) => {
    const raw = await dbPayload(`${BASE}/${op}`, "POST", siteKey, GoldenSourceHelper.prepareForApi(body || {}));
    const res = GoldenSourceHelper.normalize(raw);
    if (!res || !res.success) throw new Error(res?.message || `Single sign-on ${op} failed.`);
    return res.data;
};

/** SSO sign-in finished: store the session exactly as a password sign-in does, then hand off. */
export const commitSsoSignIn = (r) => {
    const user = r?.user || r?.User || {};
    const session = r?.session || r?.Session || {};
    const refresh = r?.refresh || r?.Refresh || {};
    authClient._commitToStorage({
        session: { sessionId: session.sessionId || session.SessionId },
        refresh: { refreshTokenId: refresh.refreshTokenId || refresh.RefreshTokenId },
        user: { guid: user.siteUserGuid || user.SiteUserGuid, email: user.emailAddress || user.EmailAddress },
        matrix: r?.matrix || r?.Matrix || [],
    });
    // Full reload so the auth and security providers hydrate from the new session.
    window.location.assign("/auth/handoff");
};
